<bb-page-header 
	[icon]="'th-list'" 
	[title]="'LINE_ITEMS' | translate" 
	[filterConfig]="filterConfig"
	[allowCustomPreset]="false"
	[currentPath]="listConfiguration.activePath">
</bb-page-header>

<bb-adstats-blocks [statsDate]="statsDate"></bb-adstats-blocks>

<div class="body-column" ng-class="{'with-stats':globalStats}">
	<p *ngIf="!publication?.disablePositions" class="warning message"><i class="fa fa-warning"></i> {{ 'ADS_ARE_DISABLED' | translate }}</p>

	<div class="options">
		<a class="button" [routerLink]="['/adservices/lineitems/new/settings']"><i class="fa fa-plus"></i>
			<span>{{ 'CREATE_NEW_LINE_ITEM' | translate }}</span>
		</a>

		<bb-date-presets
			(onChanged)="datesChanged($event)"
			[icon]="'line-chart'"
			[presets]="adServicesService.datePresets"
			[time]="true"
			[minDate]="minDate"
			[minDateWarning]="'HELP.PROJECT_STATS_DATE_CORRECTED' | translate: {date: (minDate | date)}">
		</bb-date-presets>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="code" class="overflow">{{ 'CODE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="vast_url" class="overflow">{{ 'VAST_URL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate" class="date">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="id"><span [innerHTML]="row.data.id"></span></bb-table-cell>
			<bb-table-cell property="title" class="overflow"><span [attr.title]="row.data.title" [innerHTML]="row.data.title"></span></bb-table-cell>
			<bb-table-cell property="code" class="overflow"><span [attr.title]="row.data.code" [innerHTML]="row.data.code"></span></bb-table-cell>
			<bb-table-cell property="vast_url" class="overflow"><span [attr.title]="row.data.vast_url" [innerHTML]="row.data.vast_url"></span></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell property="status"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell class="buttons">

				<a class="button" [routerLink]="['/adservices/lineitems', row.data.id, 'settings']">
					<i class="fa fa-edit"></i>
				</a><!--

				--><a class="button" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>

			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<bb-table-pager></bb-table-pager>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_LINE_ITEMS_FOUND' | translate }}</div>

</div>
